import { Controller } from "@hotwired/stimulus"

// In the category form, the start/end/extend date fields only apply to
// sub-categories. Show them when a parent category is chosen, and hide (and
// clear the editable ones) when "None" is selected so a root category is not
// submitted with dates.
export default class extends Controller {
  static targets = ["parent", "fields", "clearable", "startDate", "endDate"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasParentTarget || !this.hasFieldsTarget) return

    const show = this.parentTarget.value !== ""
    this.fieldsTarget.classList.toggle("hidden", !show)

    if (!show) {
      this.clearableTargets.forEach((el) => (el.value = ""))
    }
  }

  applyRecommendation(event) {
    const btn = event.currentTarget
    const start = btn.dataset.recommendedStart
    const end   = btn.dataset.recommendedEnd

    if (this.hasStartDateTarget && start) {
      this.startDateTarget.value = start
      this.startDateTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    if (this.hasEndDateTarget && end) {
      this.endDateTarget.value = end
      this.endDateTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
